import {
  CustomerPreference,
  customerPreferenceSchema,
} from '@sophocles/entities/CustomerPreference/customerPreferenceRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_CUSTOMER_PREFERENCES = 'RECEIVE_CUSTOMER_PREFERENCES';
export function receiveCustomerPreferences(json) {
  return {
    type: RECEIVE_CUSTOMER_PREFERENCES,
    customerPreferences: mapListToRecords(json, CustomerPreference),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CUSTOMER_PREFERENCE = 'REQUEST_CUSTOMER_PREFERENCE';
function requestCustomerPreference(customerPreference_id) {
  return {
    type: REQUEST_CUSTOMER_PREFERENCE,
    customerPreference_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCustomerPreference(customerPreference_id) {
  return dispatch => {
    dispatch(requestCustomerPreference(customerPreference_id));
    return apiClient
      .get(`/customerpreferences/${customerPreference_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'customerPreferences', customerPreferenceSchema))
      .then(json => dispatch(receiveCustomerPreferences(json.entities.customerPreferences)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_CUSTOMER_PREFERENCE));
      });
  };
}

/* Edit Actions */
export const EDIT_CUSTOMER_PREFERENCE = 'EDIT_CUSTOMER_PREFERENCE';
export function editCustomerPreference(customerPreference_id) {
  return {
    type: EDIT_CUSTOMER_PREFERENCE,
    customerPreference: customerPreference_id,
  };
}

export function patchCustomerPreference(customerPreference_id, values) {
  return dispatch => {
    dispatch(editCustomerPreference(customerPreference_id));
    return apiClient
      .patch(`/customerpreferences/${customerPreference_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, customerPreferenceSchema))
      .then(json => {
        dispatch(receiveCustomerPreferences(json.entities.customerPreferences));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_CUSTOMER_PREFERENCE));
      });
  };
}

/* Create Actions */
export const CREATE_CUSTOMER_PREFERENCE = 'CREATE_CUSTOMER_PREFERENCE';
function sayCreateCustomerPreference(values) {
  return {
    type: CREATE_CUSTOMER_PREFERENCE,
    values: values,
  };
}

export function createCustomerPreference(values) {
  return dispatch => {
    dispatch(sayCreateCustomerPreference(values));
    return apiClient
      .post(`/customerpreferences/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, customerPreferenceSchema))
      .then(json => {
        dispatch(receiveCustomerPreferences(json.entities.customerPreferences));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_CUSTOMER_PREFERENCE));
      });
  };
}

/* Delete Actions */
export const DELETE_CUSTOMER_PREFERENCE = 'DELETE_CUSTOMER_PREFERENCE';
function sayDeleteCustomerPreference(customerPreference_id) {
  return {
    type: DELETE_CUSTOMER_PREFERENCE,
    customerPreference: customerPreference_id,
  };
}

export function deleteCustomerPreference(customerPreference_id) {
  return dispatch =>
    apiClient
      .delete(`/customerpreferences/${customerPreference_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteCustomerPreference(customerPreference_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_CUSTOMER_PREFERENCE));
      });
}
